const Illustration = (props: any) => {
  return (
    <svg
      width="98"
      height="69"
      viewBox="0 0 98 69"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M89.388 0H8.12618C3.64053 0.00528202 0.00528202 3.64053 0 8.12618V60.1338C0.00528202 64.6194 3.64053 68.2547 8.12618 68.2599H89.388C89.8441 68.2618 90.2993 68.2219 90.7483 68.1413C94.6588 67.4867 97.5217 64.0987 97.5142 60.1338V8.12618C97.5089 3.64033 93.8736 0.00528202 89.388 0ZM8.12618 65.0095C5.59995 65.0091 3.49223 63.0793 3.26998 60.5628L35.6739 39.3762L68.6272 65.0095H8.12618ZM94.2637 60.1338C94.2663 62.5192 92.5385 64.5546 90.1844 64.9396C89.9215 64.9869 89.6549 65.0103 89.388 65.0095H73.9206L52.3879 48.2516L71.6437 32.8542L94.2637 46.4265V60.1338ZM94.2637 42.6365L72.3474 29.4867C71.7647 29.1362 71.0257 29.1856 70.4946 29.6102L49.7452 46.2039L36.7515 36.0981C36.204 35.6727 35.447 35.6412 34.8662 36.0201L3.25047 56.6915V8.12618C3.25047 5.43337 5.43337 3.25047 8.12618 3.25047H89.388C92.0808 3.25047 94.2637 5.43337 94.2637 8.12618V42.6365Z"
        fill="white"
      />
      <path
        d="M48.7544 9.74933C43.3687 9.74933 39.0029 14.1151 39.0029 19.5008C39.0082 24.8841 43.371 29.2469 48.7544 29.2522C54.14 29.2522 58.5058 24.8864 58.5058 19.5008C58.5058 14.1151 54.14 9.74933 48.7544 9.74933ZM48.7544 26.0017C45.164 26.0017 42.2534 23.0911 42.2534 19.5008C42.2534 15.9104 45.164 12.9998 48.7544 12.9998C52.3447 12.9998 55.2553 15.9104 55.2553 19.5008C55.2553 23.0911 52.3447 26.0017 48.7544 26.0017Z"
        fill="white"
      />
    </svg>
  )
}

export default Illustration
